import { _objectEntries, StringMap } from '@naturalcycles/js-lib/types'
import { TrKey } from '../cnst/translations/trKey.cnst'
import { ContentTypeName, LANG } from '@bm-js/atlascloud-shared'
import { ALL_TRANSLATIONS } from '../contexts/Lang.context'
import { logger } from './log.util'

export const tr = (
  key: TrKey,
  params: StringMap = {},
  currentLang: LANG
): string => {
  const translations = ALL_TRANSLATIONS[currentLang]
  let translated = translations[key]

  if (!translated) {
    logger.error(`[useTr]: Translation key ${key} not found`)
    return key
  }

  for (const [paramKey, value] of _objectEntries(params)) {
    const match = translated.includes(`{${paramKey}}`)
    if (!match) {
      logger.error(`[useTr]: param ${paramKey} not found in key ${key}`)
      continue
    }
    if (!value) {
      logger.error(`[useTr]: param ${paramKey} has no value in key ${key}`)
      continue
    }
    translated = translated.replace(`{${paramKey}}`, value)
  }

  if (translated.includes('{') || translated.includes('}')) {
    logger.error(
      `[useTr]: Translation key ${key} has unmatched params (${translated})`
    )
  }

  return translated
}

export const contentTypeTrKeyMap: Record<ContentTypeName, TrKey> = {
  accordion: TrKey.contentTypeAccordion,
  blog: TrKey.contentTypeBlog,
  button: TrKey.contentTypeButton,
  bullets: TrKey.contentTypeBullets,
  calendar: TrKey.contentTypeCalendar,
  contactform: TrKey.contentTypeContactform,
  document: TrKey.contentTypeDocument,
  form: TrKey.contentTypeForm,
  gallery: TrKey.contentTypeGallery,
  grid: TrKey.contentTypeGrid,
  header: TrKey.contentTypeHeader,
  image: TrKey.contentTypeImage,
  richtext: TrKey.contentTypeRichtext,
  sponsors: TrKey.contentTypeSponsors,
  tipsbox: TrKey.contentTypeTipsbox,
  quicklinks: TrKey.contentTypeQuicklinks,
  ytvideo: TrKey.contentTypeYtvideo,
  topsection: TrKey.contentTypeTopsection,
  videoHero: TrKey.contentTypeVideoHero,
  imageCards: TrKey.contentTypeImageCards,
  imageCollage: TrKey.contentTypeImageCollage,
  logoSection: TrKey.contentTypeLogoSection,
  serviceCard: TrKey.contentTypeServiceCard,
  dSolutionsBadge: TrKey.contentTypeDSolutionsBadge,
  foodMenu: TrKey.contentTypeFoodMenu,
  openingHours: TrKey.contentTypeOpeningHours,
}
